import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=44e136ac&scoped=true"
import script from "./Footer.vue?vue&type=script&defer=true&lang=js"
export * from "./Footer.vue?vue&type=script&defer=true&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=44e136ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e136ac",
  null
  
)

export default component.exports